import React, { MouseEventHandler, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import axios, { AxiosResponse } from 'axios';
import 'babel-polyfill';
import { formatDate, formatLongDateTime, $text, $setText, $val, $checked, $disable, $enable, redirectToError, useSearchParams, handleInverseRegexInput } from './util';
import { Appointment, IInsuranceInfo, BookingInfo } from './interfaces';
import FormWrapper, { FormTextField, FormSubmit } from './formwrapper';
import AppointmentInfo from './appointmentinfo';
import { labels } from './labels';

interface IProps {
    name: string;
    scheduleDate: Date
}

var grecaptcha = (window as any).grecaptcha;

const InsuranceInfo = (props: IProps) => {
    const [npi, start, deptid, apptType, who] = useSearchParams(["npi", "start", "deptid", "apptType", "who"]);
    const [appt, setAppt] = useState<Appointment>();
    const [carrierName, setCarrierName] = useState("");
    const [memberId, setMemberId] = useState("");
    const [groupNumber, setGroupNumber] = useState("");
    const [subscriberName, setSubscriberName] = useState("");
    const [subscriberId, setSubscriberId] = useState("");
    //const [insuranceList, setInsuranceList] = useState<Array<any>>([]);
    const [subscriberDob, setSubscriberDob] = useState<string>("");
    const [insuranceInfo, setInsuranceInfo] = useState<IInsuranceInfo>({
        carrierName: '',
        memberId: '',
        groupNumber: '',
        subscriberId: '',
        subscriberName: '',
        subscriberDob: '',
        relationshipToSubscriber: ''
    });

    const [value, setValue] = useState("");

    const history = useHistory();
    /*
    const [suggestions, setSuggestions] = useState<string[]>([]);
    
    function getSuggestions(value: string): string[] {
        return insuranceList.filter(i => i.trim().toLowerCase().indexOf(value.toLowerCase()) >= 0).slice(0, 10);
    }    
    
    useEffect(() => {
        axios.get('api/appointments/GetInsurancePlans')
            .then(result => {
                setInsuranceList(result.data);
            });
    }, [])
    */
    useEffect(() => {
        axios.get(`api/appointments?npi=${npi}&deptid=${deptid}&start=${start}&apptType=${apptType}`)
            .then((result) => {
                if (result.data) {
                    setAppt(result.data);
                    getInsuranceInfo();
                } else {
                    redirectToError(window.location.search, "INVALID_APPT");
                }
            })
    }, [])

    function getInsuranceInfo() {
        axios.get(`api/appointments/GetPersonalInfo`)
            .then((result) => {
                if (!result.data.cellPhoneVerified && !result.data.emailVerified) {
                    history.push(`/contactinfo${window.location.search}`)
                    return;
                }
                setInsuranceInfo(result.data);
                //setValue(result.data.carrierName);
                setCarrierName(result.data.carrierName);
                setMemberId(result.data.memberId);
                setGroupNumber(result.data.groupNumber);
                setSubscriberName(result.data.subscriberName);
                setSubscriberId(result.data.subscriberId);
                setSubscriberDob(result.data.subscriberDob);
            })
    }

    function saveInsuranceInfo(e: React.MouseEvent<HTMLElement>) {
        e.preventDefault();
        let temp = $text("bookButton");
        $disable("bookButton");
        $setText("bookButton", labels.insuranceinfo.waitButon);
        var fields = ["carrierName", "memberId", "groupNumber", "subscriberName", "subscriberId", "subscriberDob", "relationshipToSubscriber"];
        var info = { npi, startTime: start, departmentId: deptid, apptType } as BookingInfo;

        try {
            //document.getElementsByClassName("react-autosuggest__container")[0].classList.remove("is-invalid");
            document.getElementById("carrierName").classList.remove("is-invalid");
            FormSubmit("BOOK_APPOINTMENT", `api/appointments/SaveInsuranceInfo?who=${who}`, fields, info,
                (response) => {
                    history.push(`/bookingcomplete?bookingId=${response.data.bookingId}`)
                },
                (r) => {
                    console.log(JSON.stringify(r));

                    for (let i = 0; i < r.errors.length; i++) {
                        /*
                        if (r.errors[i].field === "carrierName") {
                            document.getElementsByClassName("react-autosuggest__container")[0].classList.add("is-invalid");
                        }*/
                    }

                    $enable("bookButton");
                    $setText("bookButton", temp);
                },
                (r) => {
                    console.log(JSON.stringify(r));
                    $enable("bookButton");
                    $setText("bookButton", temp);
                    redirectToError(window.location.search, r.error);
                }
            );
        } catch (ex) {
            console.log(JSON.stringify(ex));
            redirectToError(window.location.search, "UNEXPECTED_ERROR");
        }
    }

    if (!appt) return (<div></div>)


    function disableEnter(e: React.KeyboardEvent<HTMLInputElement>) {
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    }

    return (
        <FormWrapper currentStep={4}>
            {/*<FormProgress currentStep={4} />*/}
            <AppointmentInfo appt={appt} apptType={apptType} />

            <h2 className="mb-3 mt-3">Insurance Information</h2>
            <div className="row">
                <div className="col-md mb-3">
                    <div className="row">
                        <div className="col-md mb-3">
                            <label htmlFor="carrierName">Health Insurance*</label>
                            {/*
                    <AutoSuggest id="insurance"
                        suggestions={suggestions}
                        onSuggestionsClearRequested={() => setSuggestions([])}
                        onSuggestionsFetchRequested={({ value }) => {
                            setValue(value);
                            setSuggestions(getSuggestions(value));
                        }}
                        onSuggestionSelected={(_, { suggestionValue }) =>
                            console.log("Selected: " + suggestionValue)
                        }
                        getSuggestionValue={suggestion => suggestion}
                        renderSuggestion={suggestion => <span>{suggestion}</span>}
                        inputProps={{
                            id: "carrierName",
                            placeholder: "Enter the name of your insurance carrier",
                            value: value,
                            onChange: (_, { newValue, method }) => {
                                document.getElementsByClassName("react-autosuggest__container")[0].classList.remove("is-invalid");
                                document.getElementById("carrierName").classList.remove("is-invalid");
                                setValue(newValue);
                            },
                            onKeyPress: disableEnter,
                            className: "form-control"
                        }}
                        highlightFirstSuggestion={true}
                    />*/}
                            <input type="text" className="form-control" id="carrierName" placeholder={labels.insuranceinfo.carrier} value={carrierName} required
                                onChange={(e) => handleInverseRegexInput(e, setCarrierName, /[^0-9a-zA-Z\- ]/)} />
                            <div className="invalid-feedback">
                                Required
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <FormTextField className="col-md mb-3" id="memberId" label={labels.insuranceinfo.memberId} value={memberId} placeholder={labels.insuranceinfo.memberId} required maxLength={30}
                            onChange={(e) => handleInverseRegexInput(e, setMemberId, /[^0-9a-zA-Z\- ]/)} />
                    </div>
                    <div className="row">
                        <FormTextField className="col-md mb-3" id="groupNumber" label={labels.insuranceinfo.groupNumber} value={groupNumber} placeholder={labels.insuranceinfo.groupNumber} maxLength={30}
                            onChange={(e) => handleInverseRegexInput(e, setGroupNumber, /[^0-9a-zA-Z\- ]/)} />
                    </div>
                    <div className="row">
                        <div className="col-md mb-3">
                            <label htmlFor="relationshipToSubscriber">Relationship to Subscriber*</label>
                            <select className="custom-select d-block w-100" id="relationshipToSubscriber" defaultValue={insuranceInfo.relationshipToSubscriber}
                                onChange={
                                    (e) => {
                                        if (e.currentTarget.value === "Self" || !e.currentTarget.value) {
                                            document.getElementById('moreInsuranceInfo').style.display = "none"
                                        } else {
                                            document.getElementById('moreInsuranceInfo').style.display = "block"
                                        }
                                        document.getElementById("relationshipToSubscriber").classList.remove("is-invalid");
                                    }
                                }>
                                <option value="">Choose...</option>
                                {labels.insuranceinfo.relationshipOptions.map(o =>
                                    <option selected={insuranceInfo.relationshipToSubscriber === o} value={o}>{o}</option>
                                )}
                            </select>
                            <div className="invalid-feedback">
                                Required
                            </div>
                        </div>
                    </div>
                    <div id="moreInsuranceInfo" style={{ display: (insuranceInfo.relationshipToSubscriber === "Self" || !insuranceInfo.relationshipToSubscriber ? "none" : "block") }}>
                        <div className="row">
                            <FormTextField className="col-md mb-3" id="subscriberName" label={labels.insuranceinfo.subscriberName} value={subscriberName} placeholder={labels.insuranceinfo.subscriberName} maxLength={50}
                                onChange={(e) => handleInverseRegexInput(e, setSubscriberName, /[^a-zA-Z\- ]/)} />
                        </div>
                        <div className="row">
                            <FormTextField className="col-md mb-3"id="subscriberId" label={labels.insuranceinfo.subscriberId} value={subscriberId} placeholder={labels.insuranceinfo.subscriberId} maxLength={50}
                                onChange={(e) => handleInverseRegexInput(e, setSubscriberId, /[^0-9a-zA-Z\- ]/)} />
                        </div>
                        <div className="row">
                            <FormTextField className="col-md mb-3"id="subscriberDob" label={labels.insuranceinfo.subscriberDob} maxLength={10} mask="date" placeholder={labels.insuranceinfo.subscriberDobPlaceholder} value={subscriberDob} onChange={(e) => setSubscriberDob(e.target.value)} />
                        </div>
                    </div>
                </div>
                <div className="col-md mb-3">
                    {labels.insuranceinfo.notice}
                </div>
            </div>

            <hr className="mb-4" />
            <div className="row">
                <div className="col-md mb-4">
                    <button id="bookButton" className="btn btn-primary btn-block" type="submit" onClick={saveInsuranceInfo}>{labels.insuranceinfo.continue}</button>
                </div>
                <div className="col-md mb-4">
                    <button className="btn btn-outline-primary btn-block" type="submit" onClick={(e) => { e.preventDefault(); /*history.goBack()*/ history.push(`contactinfo${window.location.search}`) }}>{labels.insuranceinfo.backTo}</button>
                </div>
            </div>
        </FormWrapper>
    );
}

export default InsuranceInfo;